export const EDITOR_PANE_CLASSES =
    'rounded-lg border border-slate-300 dark:border-gray-800 p-2 bg-white dark:bg-gray-950';

export const DARK_BUTTON_CLASSES =
    'border-slate-400 dark:border-gray-700 btn-sm tall:btn rounded-md border bg-slate-100 dark:bg-slate-800 font-medium hover:bg-slate-200 dark:hover:bg-slate-800 active:bg-slate-300 dark:active:bg-slate-700';

export const LIGHT_BUTTON_CLASSES =
    'border-slate-400 dark:border-gray-700 btn-sm tall:btn rounded-md border bg-zinc-50 dark:bg-slate-950 font-medium hover:bg-slate-200 dark:hover:bg-slate-800 active:bg-slate-300 dark:active:bg-slate-700';

export const ICON_BUTTON_CLASSES =
    'btn btn-sm btn-square border-slate-400 dark:border-gray-700 bg-zinc-50 dark:bg-slate-900 hover:bg-slate-200 dark:hover:bg-slate-600 active:bg-slate-300 dark:active:bg-slate-700';

export const MODAL_ACTION_BUTTON_CLASSES =
    'btn border border-slate-400 bg-slate-100 text-base font-normal hover:bg-slate-200 dark:border-gray-700 dark:bg-slate-950 dark:hover:bg-slate-500';

export const MODAL_WARNING_BUTTON_CLASSES =
    'btn border border-red-400 bg-red-100 text-base font-normal hover:bg-red-200 dark:border-red-700 dark:bg-red-950 dark:hover:bg-red-500';

export const TOOLTIP_CLASSES_RIGHT = 'tooltip tooltip-right tooltip-secondary';

export const TOOLTIP_CLASSES_BOTTOM =
    'tooltip tooltip-bottom tooltip-secondary';
